import React, { useCallback, useContext, useEffect, useState } from "react";
import ReactBSAlert from "react-bootstrap-sweetalert";
import {
  Badge,
  Button,
  ListGroup,
  ListGroupItem,
  Row,
  Spinner,
} from "reactstrap";
import api from "../../../../../../services/api";
import EmpresaContext from "../../../../../../contexts/Empresa";
import { ConectarPlayneeConversasModal } from "../../../../../security/Users/me/components/Canais/modals/ConectarPlayneeConversasModal";

interface EvolutionInstance {
  numero: string;
  userName: string;
  userEmail: string;
  state: string;
  connected: boolean;
}

interface Props {
  hideTab: () => void;
}

function formatPhoneNumber(numero: string) {
  const d = numero.replace(/\D/g, "");
  if (d.length === 13) return `+${d.slice(0, 2)} (${d.slice(2, 4)}) ${d.slice(4, 9)}-${d.slice(9)}`;
  if (d.length === 12) return `+${d.slice(0, 2)} (${d.slice(2, 4)}) ${d.slice(4, 8)}-${d.slice(8)}`;
  return numero;
}

export default function EvolutionInstancesList({ hideTab }: Props) {
  const { empresaSelecionada } = useContext(EmpresaContext);
  const [instancias, setInstancias] = useState<EvolutionInstance[]>([]);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState<any>(null);
  const [modalConectar, setModalConectar] = useState(false);
  const [numeroSelecionado, setNumeroSelecionado] = useState<string | null>(null);

  const carregar = useCallback(async () => {
    if (!empresaSelecionada?.id) return;
    try {
      setLoading(true);
      const { data } = await api.get("/marketing/playnee-conversas/instancias");
      setInstancias(data);
    } catch {
      // silencioso
    } finally {
      setLoading(false);
    }
  }, [empresaSelecionada?.id]);

  useEffect(() => {
    carregar();
  }, [carregar]);

  function confirmarDesconectar(numero: string) {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block" }}
        title="Desconectar instância?"
        onConfirm={() => desconectar(numero)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="danger"
        confirmBtnText="Sim, desconectar"
        cancelBtnBsStyle="link"
        cancelBtnText="Cancelar"
        showCancel
        focusCancelBtn
      >
        O número {formatPhoneNumber(numero)} será desconectado do Playnee Conversas.
      </ReactBSAlert>
    );
  }

  async function desconectar(numero: string) {
    try {
      await api.post(`/marketing/me/playnee-conversas/desconectar/${numero}`);
      setAlert(null);
      carregar();
    } catch {
      setAlert(null);
    }
  }

  function abrirModalConectar(numero: string) {
    setNumeroSelecionado(numero);
    setModalConectar(true);
  }

  return (
    <>
      {alert}

      <ConectarPlayneeConversasModal
        isOpen={modalConectar}
        onClose={() => { setModalConectar(false); setNumeroSelecionado(null); }}
        onConnected={() => { setModalConectar(false); setNumeroSelecionado(null); carregar(); }}
        numeroAtual={numeroSelecionado}
      />

      <div className="mb-4 d-flex align-items-center justify-content-between">
        <Button color="secondary" outline onClick={hideTab}>
          Voltar
        </Button>
        <Button color="primary" outline size="sm" onClick={carregar} disabled={loading}>
          {loading ? <Spinner size="sm" /> : <><i className="fas fa-sync-alt mr-1" />Atualizar</>}
        </Button>
      </div>

      {loading && instancias.length === 0 && (
        <div className="text-center py-4">
          <Spinner color="primary" />
        </div>
      )}

      {!loading && instancias.length === 0 && (
        <p className="text-muted text-center py-4">
          Nenhum número WhatsApp cadastrado para esta empresa.
        </p>
      )}

      {instancias.length > 0 && (
        <ListGroup className="list mt-2" flush>
          <h3 className="mb-3">Números WhatsApp da empresa</h3>
          {instancias.map((inst) => (
            <ListGroupItem
              key={inst.numero}
              className="px-0 py-3"
              style={{ display: "flex", alignItems: "center", gap: "1rem" }}
            >
              <div style={{ flex: 1 }}>
                <Row className="align-items-center mx-0" style={{ gap: "0.5rem" }}>
                  <i className="fab fa-whatsapp text-success" style={{ fontSize: "1.4rem" }} />
                  <div>
                    <div style={{ fontWeight: 600, fontSize: "0.95rem" }}>
                      {formatPhoneNumber(inst.numero)}
                    </div>
                    <div style={{ fontSize: "0.82rem", color: "#6c757d" }}>
                      {inst.userName}
                    </div>
                  </div>
                  <Badge pill color={inst.connected ? "success" : "warning"} className="ml-2">
                    {inst.connected ? "Conectado" : "Desconectado"}
                  </Badge>
                </Row>
              </div>
              <div className="d-flex" style={{ gap: "0.5rem" }}>
                {!inst.connected && (
                  <Button size="sm" color="success" outline onClick={() => abrirModalConectar(inst.numero)}>
                    Conectar
                  </Button>
                )}
                {inst.connected && (
                  <Button size="sm" color="danger" outline onClick={() => confirmarDesconectar(inst.numero)}>
                    Desconectar
                  </Button>
                )}
              </div>
            </ListGroupItem>
          ))}
        </ListGroup>
      )}
    </>
  );
}
